import axiosInstance from "./AxiosInstance";

// ============================================================
// SuppliersTPServices — fornecedores TP-internos (public.suppliers).
// Distintos dos fornecedores Moloni (m_supplier) que vivem em
// SupplierMoloni / SupplierServices.
// API: api/Controllers/SupplierController.js
// ============================================================

export function getSupplierList(data) {
  return axiosInstance.post(`/supplier/list`, data);
}
export function getSupplierDetails(data) {
  return axiosInstance.post(`/supplier/details`, data);
}
export function createSupplier(data) {
  return axiosInstance.post(`/supplier/create`, data);
}
export function updateSupplier(data) {
  return axiosInstance.post(`/supplier/update`, data);
}
export function deleteSupplier(data) {
  return axiosInstance.post(`/supplier/delete`, data);
}
export function setDefaultSupplier(data) {
  return axiosInstance.post(`/supplier/set-default`, data);
}
